module.exports = __webpack_public_path__ + "img/gemrover_ebay_4.ebbfce1c.png";